import { CreateMessage } from '@store/broadcast-messages/features/create-message/create-message';
import { GetMessages } from '@store/broadcast-messages/features/get-message/get-messages';
import { GetUsersCount } from '@store/broadcast-messages/features/get-users-count/get-users-count';
import { UpdateMessage } from '@store/broadcast-messages/features/update-message/update-message';
import { all, takeLatest } from 'redux-saga/effects';

export function* broadcastMessagesSagas() {
  yield all([takeLatest(GetMessages.action, GetMessages.saga)]);
  yield all([takeLatest(CreateMessage.action, CreateMessage.saga)]);
  yield all([takeLatest(UpdateMessage.action, UpdateMessage.saga)]);
  yield all([takeLatest(GetUsersCount.action, GetUsersCount.saga)]);
}
